export default {
  articlesPath: 'articles',
  defaultArticle: 'Home',
}
